<h2 mat-dialog-title class="dialog-header">Select Companies</h2>
<mat-dialog-content class="dialog-content">
  <app-company-search-box
    [isSearchVisible]="true"
    (companySearchFilter)="onCompanySearchFilterChange($event)"
    [fieldsConfig]="fieldsConfig">
  </app-company-search-box>
  <mat-expansion-panel [expanded]="selectedCompanies.length > 0" class="selected-companies-panel">
    <mat-expansion-panel-header>
      <mat-panel-title class="selected-companies-title"> Selected Companies </mat-panel-title>
      <mat-panel-description class="selected-companies-description"> {{ selectedCompanies.length }} companies selected </mat-panel-description>
    </mat-expansion-panel-header>
    <mat-chip-set aria-label="Selected report variables">
      <mat-chip class="chip-basic-item" *ngFor="let company of selectedCompanies; let i = index">
        {{ company.companyName }}
        <mat-icon class="chip-close-icon" (click)="removeCompany(i)">close</mat-icon>
      </mat-chip>
    </mat-chip-set>
  </mat-expansion-panel>

  <app-generic-list
    [items]="companies"
    [columnDefinitions]="columnDefinitions"
    [pageSize]="pageSize"
    [pageSizeOptions]="[5, 10, 25, 50]"
    [serverSidePagination]="true"
    [totalItems]="totalItems"
    [currentPage]="currentPage"
    [rowHighlightPredicate]="isCompanySelected"
    (itemClick)="onItemClick($event)"
    (sortChange)="onSortChange($event)"
    (pageChange)="onPageChange($event)">
  </app-generic-list>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-flat-button type="button" class="nrg-error-raised-button" (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" type="button" (click)="onConfirm()">OK</button>
</mat-dialog-actions>
